import {
  IBackendCartEntries,
  IHistoricalOrder,
  ILegacyCartEntry,
  IServerOrder,
} from '@rbi-ctg/menu';
import { IRestaurant } from '@rbi-ctg/store';
import { RbiOrderStatus as OrderStatus } from 'generated/graphql-gateway';
import { ServiceMode } from 'state/service-mode/types';
import { IPlaceAddress } from 'utils/geolocation';

export { OrderStatus };

export enum CartPaymentType {
  APPLE_PAY = 'APPLE_PAY',
  CREDIT_ANONYMOUS = 'CREDIT_ANONYMOUS',
  GOOGLE_PAY = 'GOOGLE_PAY',
  VAULTED_ACCOUNT = 'VAULTED_ACCOUNT',
  CASH = 'CASH',
  PAYPAL = 'PAYPAL',
  VENMO = 'VENMO',
}

export enum DeliveryStatus {
  DRIVER_ASSIGNED = 'DRIVER_ASSIGNED',
  DRIVER_UNASSIGNED = 'DRIVER_UNASSIGNED',
  DRIVER_AT_CUSTOMER = 'DRIVER_AT_CUSTOMER',
  DRIVER_AT_STORE = 'DRIVER_AT_STORE',
  DRIVER_STARTING = 'DRIVER_STARTING',
  ORDER_ABANDONED = 'ORDER_ABANDONED',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_DROPPED_OFF = 'ORDER_DROPPED_OFF',
  ORDER_ERROR = 'ORDER_ERROR',
  ORDER_PICKED_UP = 'ORDER_PICKED_UP',
  ORDER_TIMEOUT = 'ORDER_TIMEOUT',
  QUOTE_ERROR = 'QUOTE_ERROR',
  QUOTE_REQUESTED = 'QUOTE_REQUESTED',
  QUOTE_SUCCESSFUL = 'QUOTE_SUCCESSFUL',
  QUOTE_UNAVAILABLE = 'QUOTE_UNAVAILABLE',
}

interface IFireOrderInXSecondsArgs {
  rbiOrderId: string;
  timeInSeconds: number;
}

export type FireOrderInXSeconds = (
  params: IFireOrderInXSecondsArgs
) => Promise<IServerOrder | null>;

export interface IFavoriteOrder {
  cart: {
    cartEntries: IBackendCartEntries[];
    reorderCartEntries?: IBackendCartEntries[];
    serviceMode: ServiceMode | null;
  };
  status?: OrderStatus;
}

export type IPendingReorder = IHistoricalOrder | IFavoriteOrder;

export interface ISelectOrderStore {
  newStore: IRestaurant;
  callback?: () => void;
  requestedServiceMode?: ServiceMode;
  skipChangeStoreMessage?: boolean;
}

export interface IOrderContext {
  unavailableCartEntries: ILegacyCartEntry[];
  setUnavailableCartEntries: React.Dispatch<React.SetStateAction<ILegacyCartEntry[]>>;
  serverOrder: IServerOrder | null;
  alertOrderDeliveryMinimum: () => void;
  clearServerOrder: () => void;
  selectOrderStore: ({
    newStore,
    callback,
    requestedServiceMode,
    skipChangeStoreMessage,
  }: ISelectOrderStore) => Promise<void>;
  fetchingPosData: boolean;
  clearCartStoreServiceModeTimeout: () => void;
  logCartStoreAndTimeout: (resetStoreTimeout: number, timeSinceLastVisit: number) => void;
  deliveryAddress: IPlaceAddress | null;
  setDeliveryAddress: React.Dispatch<React.SetStateAction<IPlaceAddress | null>>;
  deliveryInstructions: string | undefined;
  setDeliveryInstructions: React.Dispatch<React.SetStateAction<string | undefined>>;
  orderPhoneNumber: string;
  setOrderPhoneNumber: React.Dispatch<React.SetStateAction<string>>;
  pickupDate: Date | null;
  setPickupDate: React.Dispatch<React.SetStateAction<Date | null>>;
  onCommitSuccess: (serverOrder: IServerOrder) => Promise<void>;
  updateShouldSaveDeliveryAddress: (shouldSave: boolean) => void;
  quoteId: string;
  setQuoteId: React.Dispatch<React.SetStateAction<string>>;
  fireOrderInXSeconds: FireOrderInXSeconds;
  reorder: {
    handleReorder: (order: IPendingReorder, url?: string) => Promise<void>;
    resetPendingReorder: () => void;
    reordering: boolean;
    setReordering: React.Dispatch<React.SetStateAction<boolean>>;
    pendingReorder: IPendingReorder | null;
    setPendingReorder: React.Dispatch<React.SetStateAction<IPendingReorder | null>>;
    reorderedOrderId: string | null;
    setShouldHandleReorder: (bool: boolean) => void;
  };
  recent: {
    pendingRecentItem: ILegacyCartEntry | null;
    setPendingRecentItem: React.Dispatch<React.SetStateAction<ILegacyCartEntry | null>>;
    unavailablePendingRecentItem: ILegacyCartEntry | null;
    setUnavailablePendingRecentItem: React.Dispatch<React.SetStateAction<ILegacyCartEntry | null>>;
  };
  shouldSaveDeliveryAddress: boolean;
  setShouldSaveDeliveryAddress: React.Dispatch<React.SetStateAction<boolean>>;
  formShouldSaveDeliveryAddress: boolean;
  setFormShouldSaveDeliveryAddress: React.Dispatch<React.SetStateAction<boolean>>;
  isStoreChangeHydrationInProgress: boolean;
}
